<div class="flex-fill d-flex flex-column">
    <div class="m-1 grid-fill" *ngIf="contactLogs">
        <dx-data-grid
            #dataGrid
            keyExpr="id"
            [dataSource]="contactLogs"
            [columnAutoWidth]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onSelectionChanged)="selectionChange($event)"
            (onCellDblClick)="rowDoubleClick($event)"
            (onExporting)="onExporting($event)"
        >
            <dxi-column dataField="noteDate" caption="Date" format="shortDateShortTime" width="160" [sortIndex]="0" sortOrder="desc"></dxi-column>
            <dxi-column dataField="contactType.name" caption="Type" width="100"></dxi-column>
            <dxi-column dataField="contactMethod.name" caption="Method" width="100"></dxi-column>
            <dxi-column dataField="dealer.companyName" caption="Dealer" width="190" ></dxi-column>
            <dxi-column dataField="vendor.companyName" caption="Vendor" width="190" ></dxi-column>
            <dxi-column dataField="companyName" width="80"></dxi-column>
            <dxi-column dataField="contactName" width="80"></dxi-column>
            <dxi-column dataField="phoneNumber" caption="Phone" width="120"></dxi-column>
            <dxi-column dataField="email" caption="Email" width="120"></dxi-column>
            <dxi-column dataField="reason"></dxi-column>
            <dxi-column dataField="resolution"></dxi-column>
            <dxi-column dataField="note" width="200"></dxi-column>
            <dxi-column dataField="createdBy"></dxi-column>

            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="contact-log-search-grid"></dxo-state-storing>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button class="btn btn-secondary me-2" (click)="add()">New</button>
                <button class="btn btn-success" (click)="add(dataGrid.instance.getSelectedRowsData()[0])">Open</button>
                <button
                    class="btn btn-danger ms-2"
                    (click)="delete()"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
                    [hidden]="!auth.hasRole('ContactLog:Admin')"
                >
                    Delete
                </button>
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="contactLogs" class="me-3"
                    ><strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong></span
                >
            </div>
        </dx-data-grid>
    </div>
</div>
